export const notFound = { textAlign: "center", width: "100%" };

export const gridContainerStyles = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "15px",
};

export const gridItemStyles = {
  textDecoration: "none",
};

